import * as React from 'react';
import { useControllableState } from '../../utils/useControllableState.tsx';
import Field, { FieldProps } from './Field.tsx';
import classnames from '../../utils/classnames.tsx';

export interface TextFieldProps
    extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'defaultValue'>,
        FieldProps {
    inputClassName?: string;
}

const TextField = ({
    ref,
    defaultValue,
    value: propsValue,
    onValueChange,
    onChange,
    onBlur,
    onCommit,
    readOnly,
    disabled,
    className,
    inputClassName,
    controls,
    inputRef = undefined,
    maxLength,
    ...props
}: TextFieldProps) => {
    const [value, setValue] = useControllableState(defaultValue, propsValue, onValueChange);

    const handleChange = (e: any) => {
        setValue(e.target.value);
        onChange?.(e);
    };

    const handleBlur = (e: any) => {
        onBlur?.(e);
        onCommit?.(value);
    };

    return (
        <Field className={className} readOnly={readOnly} disabled={disabled} ref={ref}>
            <Field.Input className="relative">
                <textarea
                    className={classnames(
                        'px-2 py-1.5 flex-1 min-w-0 h-24 resize-none bg-surface-transparent outline-none',
                        inputClassName
                    )}
                    readOnly={readOnly}
                    disabled={disabled}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={value || ''}
                    maxLength={maxLength}
                    {...props}
                    ref={inputRef}
                />
                {maxLength && (
                    <div className="text-xs text-content-medium bottom-1 right-0.5 absolute bg-surface-weak px-1 py-0.5 rounded pointer-events-none">
                        {(value || '').length}/{maxLength}
                    </div>
                )}
            </Field.Input>
            <Field.Controls>{controls}</Field.Controls>
        </Field>
    );
};

export default TextField;
